import { useState } from 'react';
import { useGetDashBoard } from '../Dashboard/api';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { useGetReferral } from './api';
import { useTranslation } from 'react-i18next';

const Transaction = (props) => {

    const [page, setPage] = useState(1);
    const [refPage , setRefPage] = useState(1)
    const {t} = useTranslation()
    const size = 10
    const [activeTab, setActiveTab] = useState('1');
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const { data: getDashboard } = useGetDashBoard({ page, size })

    const total = getDashboard?.transactions?.length

    const totalPages = Math.ceil(total / size);

    const {data : getReferral } = useGetReferral({page, size})

    const refferalCount = getReferral?.data?.length || 0

    const totalCount = Math.ceil(refferalCount / size)

    return (
        <div className='TrnsctnPg'>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => { toggle("1"); }}
                        style={{cursor:'pointer'}}
                    >
                        {t('Transactions')}
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => { toggle("2"); }}
                        style={{cursor:'pointer'}}
                    >
                       {t('Referrals')}
                    </NavLink>
                </NavItem>
            </Nav>

            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <div className="TrnsctnDts">
                        <div className="TrnsctnDtsTp">
                            <h4>{t('Transactions List')}</h4>
                        </div>
                        <div className='table-responsive px-3'>
                            <table className='table' aria-hidden='true'>
                                <thead>
                                    <th>{t('Date & Time')}</th>
                                    <th>{t('Tranx No')}</th>
                                    <th>{t('Currency')}</th>
                                    <th>{t('Amount')}</th>
                                    <th>{t('Type')}</th>
                                    <th>{t('Payment Type')}</th>
                                    <th>{t('Status')}</th>
                                </thead>
                                <tbody>
                                    {
                                        getDashboard?.transactions?.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" style={{ textAlign: 'center' }}>{t('No data found')}</td>
                                            </tr>
                                        ) : (
                                            getDashboard?.transactions?.map((v, i) => (
                                                <tr key={v?.id}>
                                                    <td>{new Date(v.createdAt).toLocaleString()}</td>
                                                    <td>{v.trx_id ? v.trx_id : "--"}</td>

                                                    <td>{v.fromCurrency}</td>
                                                    <td>{v.totalAmount} KKOG</td>
                                                    <td >{v.status ? <span className='Grn'>{t('Purchase')}</span> : <span className='Grn'>{t('Pending')}</span>}</td>
                                                    <td>{v.paymentType}</td>

                                                    <td>{v.status ? <img src={require('../../assets/images/tick-circle.png')} alt='' /> : <img src={require('../../assets/images/close-circle-red.png')} alt='' />}</td>
                                                </tr>
                                            ))
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </TabPane>
                <TabPane tabId="2">
                    <div className="TrnsctnDts">
                        <div className="TrnsctnDtsTp">
                            <h4>{t('Referral List')}</h4>
                        </div>
                        <div className='table-responsive px-3'>
                            <table className='table' aria-hidden='true'>
                                <thead>
                                    <th>{t('S.No')}</th>
                                    <th>{t('Email')}</th>
                                    <th>{t('Username')}</th>
                                    <th>{t('Reward Amount')}</th>
                                    <th>{t('Type')}</th>
                                    <th>{t('Date & Time')}</th>
                                </thead>
                                <tbody>
                                {
                                        getReferral?.message === 'No data found!' ? (
                                            <tr>
                                                <td colSpan="7" style={{ textAlign: 'center' }}>{t('No data found')}</td>
                                            </tr>
                                        ) : (
                                            getReferral?.data?.map((v, index) => (
                                                <tr key={v?.id}>
                                                    <td>{index+1}</td>
                                                    <td>{v.userDetails?.email}</td>
                                                    <td>{v.userDetails?.userName}</td>
                                                    <td >{v.rewardAmount}</td>
                                                    <td style={{color:'#1BBC51'}}>Referral</td>
                                                    <td>{new Date(v.createdAt).toLocaleString()}</td>
                                                </tr>
                                            ))
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </TabPane>
            </TabContent>
            {activeTab == '1' ? 
        <div className="PgntnDv">
        <span>
            {t('Showing')} {(page - 1) * size + 1} {t('to')} {Math.min(page * size, total)} {t('of')} {total} {t('entries')}
        </span>
        <nav aria-label="Page navigation example">
            <ul className="pagination">
                {page > 1 && (
                    <li className="page-item">
                    <button style={{all:"unset",cursor:"pointer"}} onClick={() => setPage(page - 1)}>
                    <span className="page-link"  >
                            {t('Previous')}
                        </span>
                    </button>
                    </li>
                )}
                {totalPages > 0 && Array.from({ length: totalPages }, (_, index) => (
                    <li key={index} className={`page-item ${page === index + 1 ? 'active' : ''}`}>
                    <button style={{all:"unset",cursor:"pointer"}}  onClick={() => setPage(index + 1)}>
                        <span
                            className="page-link"
                            
                        >
                            {index + 1}
                        </span>
                        </button>
                    </li>
                ))}
                {page < totalPages && (
                    <li className="page-item">
                    <button style={{all:"unset",cursor:"pointer"}}  onClick={() => setPage(page + 1)} >
                    <span className="page-link"  >
                            {t('Next')}
                        </span>
                    </button>
                    </li>
                )}
            </ul>
        </nav>
    </div> : <div className="PgntnDv">
                <span>
                    {t('Showing')} {(refPage - 1) * size + 1} {t('to')} {Math.min(refPage * size, refferalCount)} {t('of')} {refferalCount} {t('entries')}
                </span>
                <nav aria-label="Page navigation example">
                    <ul className="pagination">
                        {refPage > 1 && (
                            <li className="page-item">
                            <button style={{all:"unset",cursor:"pointer"}} onClick={() => setRefPage(refPage - 1)}>

                                <span className="page-link">
                                    {t('Previous')}
                                </span>
                            </button>
                            </li>
                        )}
                        {totalCount > 0 && Array.from({ length: totalCount }, (_, index) => (
                            <li key={index} className={`page-item ${page === index + 1 ? 'active' : ''}`}>
                             <button style={{all:"unset",cursor:"pointer"}}  onClick={() => setRefPage(index + 1)}>

                                <span
                                    className="page-link"
                                

                                >
                                    {index + 1}
                                </span>
                            </button>

                            </li>
                        ))}
                        {refPage < totalCount && (
                            <li className="page-item">
                            <button style={{all:"unset",cursor:"pointer"}}   onClick={() => setRefPage(refPage + 1)}>
                                <span className="page-link">
                                    {t('Next')}
                                </span>
                            </button>
                            </li>
                        )}
                    </ul>
                </nav>
            </div>    
        
        }
        </div>
    );
}

export default Transaction;